module.exports = __webpack_public_path__ + "img/IMG_8910.3a8e935f.jpg";